import { Environment } from './types';

export const environment: Environment = {
	production: true,
	deviceCareApiDomain: 'https://6j530gbjgl.execute-api.us-east-1.amazonaws.com/prod',
	deviceSelectionDomain: 'https://www.asurion.com', // NOTE: can probably be removed once migrated to OSPv2
	ubifApiDomain: 'https://api.tech-care.solutotlv.asurion53.com',
	localizationNamespace: 'device-care',
	evidentlyProject: 'device-care-api-mxDeviceCare',
	deviceCareV2Url: 'https://asurion.com/device-health-check',
	serviceArticles: {
		att: {
			sanitization: '7crbcxkazrJZxS5m6JCuyg',
		},
		default: {
			sanitization: '1uTmCPkbRjhF1bs3h0D18b',
			performance: '72cGaXAXQdTpZ9UEaVRmXK',
			performanceYear2: '5lQhP7oiwIQz9xHe8tG9Jz',
			recovery: '5e5m83PkvQvZzaoXOifvuj',
			deviceDiagnostics: '72EpBkCxBcUFcmuzD1epbL',
		},
	},
	contentful: {
		article: {
			spaceId: 'vny2voxhx17a',
			accessToken: 'ftp4mLD6W7Am4R5CZKznm2ahvM9x-hjKwMydkB5IDRQ',
			environment: 'product-diy',
		},
		checkup: {
			spaceId: 'rmlmaoupstcv',
			accessToken: 'gVYfOoIU3D0Tm3zbgqzy0DesFVKUO6xIpeqmXMN_-bk',
			environment: 'master',
		},
		page: {
			spaceId: 'vny2voxhx17a',
			accessToken: 'K-goJcLisfw5tsirXsGIjh6N4-1vI-ouoM3UKjl5NfM',
			environment: 'device-care',
		},
	},
	asurionId: {
		apiDomain: 'https://id.asurion.com',
		clientId: '4c007156-ec0d-48d3-8bbb-34c07884e693',
	},
};
